// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1gFDj","rootSmall":"AddTileButton_rootSmall__zryFk"};